<template>
    <module-card>
        <p>So how hard do you think it would be for P to stick to his BottomLine in this situation?</p>
        <v-slider v-model="sliderChoice" :max="9" step="1" track-color="primary" thumb-color="red" ticks="always" tick-size="5"></v-slider>
        <div class="arrow-container">
            <div class="arrow-label">Easy</div>
            <div class="arrow-wrapper">
                <div class="arrow middle"></div>
            </div>
            <div class="arrow-label">Really super hard</div>
        </div>
    </module-card>
</template>

<script>
    export default {
        data() {
            return {
                sliderChoice: 5
            };
        }
    };
</script>

<style scoped>
    ::v-deep .v-slider__tick {
        background-color: var(--v-primary-base);
    }

    .selected-text {
        white-space: pre-wrap;
    }

    .arrow-label {
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        width: 85px;
    }

    .arrow-wrapper {
        display: flex;
        width: 100%;
        align-items: center;
    }

    .arrow-container {
        display: flex;
        padding: 0px;
    }
    .middle {
        flex-grow: 1;
    }

    .arrow {
        position: relative;
        margin: 12px 20px;
        height: 0;
        border-bottom: 1px dotted var(--v-primary-base);
    }

    .arrow::after {
        content: '';
        width: 0;
        height: 0;
        border-top: 8px solid transparent;
        border-bottom: 8px solid transparent;
        border-left: 12px solid var(--v-primary-base);
        position: absolute;
        right: -10px;
        top: -8px;
    }

    .arrow::before {
        content: '';
        width: 0;
        height: 0;
        border-top: 8px solid transparent;
        border-bottom: 8px solid transparent;
        border-right: 12px solid var(--v-primary-base);
        position: absolute;
        left: -10px;
        top: -8px;
    }
</style>
